import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export function bringElementsForward(store: StoreType, elements: ElementsArray) {
    store.activePage.moveElementsUp(elements.map(element => element.id));
}
